import React, { ReactNode } from 'react';

type TooltipProps = {
    content: string;
    direction?: 'top' | 'bottom' | 'left' | 'right';
    children: ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ content, direction = 'top', children }) => {
    return (
        <span
            data-tooltip={content}
            className={`has-tooltip tip-${direction}`}
        >
            {children}
        </span>
    );
};

export default Tooltip;
